import React, { Component } from 'react'
import webApi from '../../../../../../utilities/web-api';
import { header } from './../../../../../../utilities/page';

export default class CreateCategory extends Component {
    state = {}

    componentWillMount(){
        webApi.getCategoryId(this.props.id_category).then(data => {
            if(data.status === 200){
                this.setState({category: data.response[0].title}, () => console.log(this.state.category))
            }
        })
    }

    handleCreate = () => {
        let {title} = this.state
        if(!title) return header.getSnackbar("Название категории не заполнено")

        webApi.updateCategoryId({id: this.props.id_category,title})
        .then(data => {
            if(data.status === 200){
                header.getSnackbar("Категория обновлена")
                this.props.handlePage('view')
            }
        })
    }

    handleInput = e => {
        this.setState({[e.target.name]:e.target.value}, () => console.log(this.state.title))
    }

    render() {
        return (  
            <div>
                <span className="href" onClick={() => this.props.handlePage('view')}><i className="fas fa-arrow-left color-blue"></i> Вернуться назад</span><br/><br/>     
                <div className="create-form">
                    <span><b>Название категории</b></span> <br/>
                    <input name = "title" onChange={this.handleInput} defaultValue={this.state.category && this.state.category} type="text" placeholder="Введите название категории"/> <br/><br/>
                    <div className="btnSaveProfile fl-left" onClick={this.handleCreate}>Обновить</div>
                </div>
            </div>
        )
    }
}